<template>
  <div>
    <PageTitle title="Shop Stock Details" :btnCreate="true" />
    <!--  -->
    <v-container
      fluid
      class="lighten-12 content"
      style="background-color: white"
    >
      <!-- <hr style="border-top: 1px dashed rgb(173 173 173)" /> -->
      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content" v-show="show">
          <TableFilters
            :filters="['product', 'shop', 'search', 'category']"
            v-model="filter"
            :columns="columns"
            :msgs="'Product'"
          ></TableFilters>
        </v-card>
      </v-expand-transition>

      <v-card class="mt-2">
        <v-container fluid>
          <v-row>
            <v-card-text class="pa-0">
              <v-data-table
                :items-per-page="paginationOptions.perPage"
                :fixed-header="true"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                @click:row="GetBatchDetails($event)"
                show-expand
                :headers="headers"
                :items="stocks"
                item-key="id"
                hide-default-footer
                class="row-pointer product-list bld-100"
                dense
                style="
                  font-weight: normal;
                  font-family: 'Source Sans Pro', sans-serif;
                "
              >
                <template v-slot:item.shop.name="{ item }">
                  {{ ShopView == 'name' ? item.shop.name : item.shop.sortform }}
                </template>
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-btn
                      @click="openTransferModal()"
                      v-if="tansferToggle && selectedItemToTransfer.length > 0"
                      color="primary"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Transfer
                    </v-btn>
                    <v-spacer></v-spacer>
                    <permission-control permissionName="Stock Transfer">
                      <v-switch
                        v-model="tansferToggle"
                        label="Transfer Stock"
                        class="mt-2"
                      ></v-switch>
                    </permission-control>
                  </v-toolbar>
                </template>
                <template v-slot:item.available_stock="{ item }">
                  <v-chip
                    :x-small="true"
                    class="ma-2"
                    label
                    text-color="white"
                    :color="getStockColor(item)"
                    dark
                    >{{ item.available_stock }}</v-chip
                  >
                </template>
                <template
                  v-slot:expanded-item="{ headers, item: childItem, item }"
                >
                  <td :colspan="headers.length">
                    <v-card class="pa-0 mt-3 mb-3">
                      <v-data-table
                        dense
                        :items="stockBatches"
                        :headers="batchHeaders"
                        class="sub-table"
                      >
                        <template v-slot:item.isTransferable="{ item }">
                          <v-checkbox
                            v-if="tansferToggle && item.available_stock > 0"
                            v-model="item.isTransfer"
                            color="indigo darken-3"
                            @change="AddItemToTransfer(item)"
                            hide-details
                          ></v-checkbox>
                        </template>
                        <v-progress-linear
                          v-show="progressBar"
                          slot="progress"
                          color="blue"
                          indeterminate
                        ></v-progress-linear>

                        <!-- Action -->
                        <template v-slot:item.action="{ item }">
                          <permission-control
                            permissionName="Shop Stock Adjustment"
                          >
                            <v-list-item link @click="EditStockDetails(item)">
                              <span>
                                <v-icon v-bind="attrs" v-on="on"
                                  >mdi-pencil-box-outline</v-icon
                                >Edit
                              </span>
                            </v-list-item>
                          </permission-control>
                        </template>
                      </v-data-table>
                    </v-card>
                  </td>
                </template>

                <template v-slot:no-data>
                  <noData
                    class="mt-10 container justify-center item-center"
                    name="shop"
                  />
                </template>

                <template v-slot:item.image="{ item }">
                  <v-avatar size="24px" item color="primary">
                    <img v-if="item.product.image" :src="item.product.image" />
                    <span v-else class="white--text subtitle-3 text-uppercase">
                      {{ item.product.name.substring(0, 2) }}</span
                    >
                  </v-avatar>
                </template>
                <template
                  v-slot:item.data-table-expand="{ item, isExpanded, expand }"
                >
                  <span
                    @click="GetBatchDetails($event)"
                    v-if="
                      (expanded.length > 0 && item.id != expanded[0].id) ||
                      expanded.length == 0
                    "
                    class="mdi mdi-chevron-double-down"
                  ></span>
                  <span
                    @click="GetBatchDetails($event)"
                    v-if="expanded.length > 0 && item.id == expanded[0].id"
                    class="mdi mdi-chevron-double-up"
                  ></span>
                </template>
                <template v-slot:footer>
                  <pagination
                    @paginationOptions="setPaginationOptions"
                    @response="setResponseData"
                    @getPageNumber="setPagenumber"
                    url="shop-stocks"
                    :filterAction="true"
                    :filter="filter"
                    ref="pagination"
                  />
                </template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>

      <div class="d-flex justify-center align-center"></div>
      <!-- </v-row> -->
    </v-container>
    <ShopToShopStockTransfer
      :productDetails="selectedItemToTransfer"
      ref="TransferForm"
      @saved="refreshStocks($event)"
    />

    <ShopAdjustable
      :visible="isCategoryFormVisible"
      :StockAdjustment="ShopStockDetails"
      @close="AddCategory($event)"
      @afterSave="refreshStocks()"
    />
  </div>
</template>

<script>
import ShopAdjustable from './ShopAdjustable';
// Components
import ShopToShopStockTransfer from './ShopToShopStockTransfer';
import PageTitle from '@/components/shared/PageTitle';
import pagination from '../shared/components/pagination';
import TableFilters from '@/components/base/TableFilters';
import uniq from 'lodash/uniq';
import { mapState } from 'vuex';

import { required, email, max } from 'vee-validate/dist/rules';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import _ from 'lodash';
import noData from '../../components/shared/noItem';
extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
});

extend('email', {
  ...email,
  message: 'Email must be valid',
});

export default {
  data: () => ({
    show: false,
    tansferToggle: false,
    isCategoryFormVisible: false,
    selectedProductDetails: null,
    selectedItemToTransfer: [],
    paginationOptions: {},
    progressBar: false,
    editBatchId: null,
    batchHeaders: [
      {
        text: 'Batch',
        value: 'batch.batch',
        show: true,
        align: 'left',
        disabled: true,
        width: '14.2%',
      },
      {
        text: 'In Stock',
        value: 'available_stock',
        show: true,
        align: 'center',
        disabled: true,
        width: '14.2%',
      },
      {
        text: '',
        value: 'isTransferable',
        show: true,
        disabled: false,
        align: 'center',
        width: '14.2%',
      },
      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        align: 'center',
        width: '6%',
      },
    ],
    columns: [
      {
        text: 'Image',
        value: 'image',
        show: true,
        disabled: true,
        align: 'left',
        width: '10%',
      },
      {
        text: 'Product',
        value: 'product.name',
        show: true,
        disabled: true,
        align: 'left',
        width: '14.2%',
      },
      {
        text: 'Category',
        value: 'product.category.name',
        show: true,
        disabled: true,
        align: 'left',
        width: '20%',
      },
      {
        text: 'Unit',
        value: 'unit.name',
        align: 'left',
        show: true,
        disabled: false,
      },
      {
        text: 'Shop',
        value: 'shop.name',
        show: true,
        disabled: false,
        align: 'left',
        width: '14.2%',
      },
      {
        text: 'In Stock',
        value: 'available_stock',
        show: true,
        disabled: false,
        align: 'center',
        width: '14.2%',
      },
      {
        text: 'Reorder Level',
        value: 'reorder_level',
        show: true,
        disabled: false,
        align: 'center',
        width: '14.2%',
      },
    ],
    products: [],
    stocks: [],
    expanded: [],
    singleExpand: true,
    stockBatches: [],
    selectedShop: null,
    ShopStockDetails: {
      shop_id: null,
      product_id: null,
      batch_id: null,
      unit_id: null,
    },
    // Filters
    filter: {
      search: '',
      product: '',
      status: '',
      shop: '',
      category: '',
    },
  }),
  components: {
    PageTitle,
    ValidationProvider,
    ValidationObserver,
    pagination,
    TableFilters,
    ShopToShopStockTransfer,
    ShopAdjustable,
    noData,
  },
  methods: {
    EditStockDetails(data) {
      this.isCategoryFormVisible = true;
      this.editBatchId = data.batch.id;
      this.ShopStockDetails.batch_id = data.batch.id;
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },

    AddCategory($event) {
      this.isCategoryFormVisible = false;
    },
    refreshStocks() {
      this.$refs.pagination.refreshData();
      this.selectedItemToTransfer = [];
      this.selectedShop = null;
      this.tansferToggle = null;
      this.GetBatchDetails(this.selectedProductDetails);
    },
    AddItemToTransfer(item) {
      let productBatch = new Object();

      productBatch.productDetail = this.selectedProductDetails;
      productBatch.details = item;
      productBatch.productDetail.quantity = item.available_stock;
      productBatch.productDetail.maxStock = item.available_stock;
      // productBatch.productDetail.available_stock=item.available_stock;

      if (
        this.selectedShop &&
        this.selectedShop != this.selectedProductDetails.shop.id
      ) {
        this.$confirm(
          `you can transfer to one shop at a time Do you want to change to new shop  previous selected shop Transfer will be lost`,
        ).then((res) => {
          if (res) {
            this.selectedItemToTransfer = [];
            this.selectedShop = this.selectedProductDetails.shop.id;
            if (item.isTransfer) {
              item.error = [];

              this.selectedItemToTransfer.push(_.cloneDeep(productBatch));
            } else {
              let index = this.selectedItemToTransfer.findIndex(
                (p) =>
                  p.productDetail.product.id ==
                    this.selectedProductDetails.product.id &&
                  p.productDetail.shop.id == item.shop.id &&
                  p.details.batch.id == item.batch.id,
              );
              if (index != -1) {
                this.selectedItemToTransfer.splice(index, 1);
              }
            }
          } else {
            item.isTransfer = false;
          }
        });
      } else {
        this.selectedShop = this.selectedProductDetails.shop.id;
        if (item.isTransfer) {
          item.error = [];
          this.selectedItemToTransfer.push(_.cloneDeep(productBatch));
          item.quantity = item.available_stock;
        } else {
          let index = this.selectedItemToTransfer.findIndex(
            (p) =>
              p.productDetail.product.id ==
                this.selectedProductDetails.product.id &&
              p.productDetail.shop.id == this.selectedProductDetails.shop.id &&
              p.details.batch.id == item.batch.id,
          );
          if (index != -1) {
            this.selectedItemToTransfer.splice(index, 1);
          }
        }
      }
    },
    openTransferModal() {
      this.$refs.TransferForm.openModal();
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    setResponseData(stock) {
      this.stocks = stock;
    },
    clearFilter() {
      this.filter = {};
    },
    GetBatchDetails(event) {
      this.selectedProductDetails = event;
      this.progressBar = true;
      if (this.expanded.length > 0 && this.expanded[0].id == event.id) {
        this.expanded = [];
      } else {
        const payload = new Object();
        payload.product_id = event.product.id;
        payload.shop_id = event.shop.id;
        payload.unit_id = event.unit.id;
        this.ShopStockDetails.product_id = event.product.id;
        this.ShopStockDetails.shop_id = event.shop.id;
        this.ShopStockDetails.unit_id = event.unit.id;

        this.$store
          .dispatch('stock/GetShopBatchStocksOnExpand', payload)
          .then((resp) => {
            this.progressBar = false;

            this.stockBatches = resp.map((r) => {
              let selectedProduct = this.selectedItemToTransfer.find(
                (p) =>
                  p.productDetail.product.id == event.product.id &&
                  p.productDetail.shop.id == event.shop.id &&
                  p.details.batch.id == r.batch.id,
              );
              if (selectedProduct) {
                r.isTransfer = true;
              } else {
                r.isTransfer = false;
              }
              return r;
            });
          })
          .catch((error) => console.log(error));
        this.expanded = [];
        this.progressBar = false;
        this.expanded.push(event);
      }
    },
    getStockColor(stock) {
      if (
        0 < stock.available_stock &&
        stock.available_stock < stock.reorder_level
      ) {
        return 'orange';
      } else if (stock.available_stock < 1) {
        return 'red';
      } else {
        return 'green';
      }
    },
  },
  computed: {
    ...mapState(['ShopView']),
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {},
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');
.bld-100 {
  font-weight: bold;
}
.filterclor {
  color: cornflowerblue;
  font-size: larger;
  font-weight: bold;
}
.min-button::before {
  display: none;
}
</style>
